import Page from "../Common/Page";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import React from "react";
import { Form, Row, Col, Button, Space, Table, message } from "antd";
import { AuthContext } from "../Auth/Auth";
import { http } from "../Common/http";
import { Messages } from "../Common/ValidateMessages";
import { NavigateFunction } from "react-router-dom";
import withRouterDom from "../Common/WithReactRouterDom";
import { AuthorityButton } from "../Components/AuthorityButton";
import { localeCompare } from "../Common/Utils";

// type FormData = {
//   fy: number;
//   entranceExam1Id: string;
//   entranceExam2Id: string;
//   entranceExam3Id: string;
//   facultyId: string;
//   departmentId: string;
//   majorId: string;
//   courceId: string;
//   attachedInformation1Id: string;
//   attachedInformation2Id: string;
//   attachedInformation3Id: string;
// };

interface Props {
  navigation: NavigateFunction;
  location: any;
}
interface ExaminationSearchRequestBean {
  fy: string;
  entranceExam1Id: string | undefined;
  entranceExam2Id: string | undefined;
  entranceExam3Id: string | undefined;
  facultyId: string | undefined;
  departmentId: string | undefined;
  majorId: string | undefined;
  courceId: string | undefined;
  attachedInformation1Id: string | undefined;
  attachedInformation2Id: string | undefined;
  attachedInformation3Id: string | undefined;
}
interface ExaminationSearchResponseBean {
  fy: string;
  examinationId: string;
  entranceExam1Name: string;
  entranceExam2Name: string;
  entranceExam3Name: string;
  facultyName: string;
  departmentName: string;
  majorName: string;
  courceName: string;
  attachedInformation1Name: string;
  attachedInformation2Name: string;
  attachedInformation3Name: string;
  status: string;
}

export class UserList extends React.Component<Props, any> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  constructor(props: Props, context) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
    const { location } = this.props;
    this.state = {
      examinationList: [],
      page: 1,
      pageSize: 10,

      fy: location.state?.fy
        ? location.state?.fy
        : context.user.currentYear.toString(),
      entranceExam1Id: location.state?.entranceExam1Id
        ? location.state?.entranceExam1Id
        : undefined,
      entranceExam2Id: location.state?.entranceExam2Id
        ? location.state?.entranceExam2Id
        : undefined,
      entranceExam3Id: location.state?.entranceExam3Id
        ? location.state?.entranceExam3Id
        : undefined,
      facultyId: location.state?.facultyId
        ? location.state?.facultyId
        : undefined,
      departmentId: location.state?.departmentId
        ? location.state?.departmentId
        : undefined,
      majorId: location.state?.majorId ? location.state?.majorId : undefined,
      courceId: location.state?.courceId ? location.state?.courceId : undefined,
      attachedInformation1Id: location.state?.attachedInformation1Id
        ? location.state?.attachedInformation1Id
        : undefined,
      attachedInformation2Id: location.state?.attachedInformation2Id
        ? location.state?.attachedInformation2Id
        : undefined,
      attachedInformation3Id: location.state?.attachedInformation3Id
        ? location.state?.attachedInformation3Id
        : undefined,
    };
  }

  componentDidMount = async () => {
    const { location } = this.props;
    if (location.state) {
      this.onSearch();
    }
  };

  // 選択項目変更
  onChangeFy = (newValue: any) => {
    this.setState({
      fy: newValue !== undefined ? newValue.value : undefined,
      entranceExam1Id: undefined,
      entranceExam2Id: undefined,
      entranceExam3Id: undefined,
      facultyId: undefined,
      departmentId: undefined,
      majorId: undefined,
      courceId: undefined,
      attachedInformation1Id: undefined,
      attachedInformation2Id: undefined,
      attachedInformation3Id: undefined,
    });
  };
  onChangeEntranceExam1Id = (newValue: any) => {
    this.setState({
      entranceExam1Id: newValue !== undefined ? newValue.value : undefined,
      entranceExam2Id: undefined,
      entranceExam3Id: undefined,
    });
  };
  onChangeEntranceExam2Id = (newValue: any) => {
    this.setState({
      entranceExam2Id: newValue !== undefined ? newValue.value : undefined,
      entranceExam3Id: undefined,
    });
  };
  onChangeEntranceExam3Id = (newValue: any) => {
    this.setState({
      entranceExam3Id: newValue !== undefined ? newValue.value : undefined,
    });
  };
  onChangeFacultyId = (newValue: any) => {
    this.setState({
      facultyId: newValue !== undefined ? newValue.value : undefined,
      departmentId: undefined,
      majorId: undefined,
      courceId: undefined,
    });
  };
  onChangeDepartmentId = (newValue: any) => {
    this.setState({
      departmentId: newValue !== undefined ? newValue.value : undefined,
      majorId: undefined,
      courceId: undefined,
    });
  };
  onChangeMajorId = (newValue: any) => {
    this.setState({
      majorId: newValue !== undefined ? newValue.value : undefined,
      courceId: undefined,
    });
  };
  onChangeCourceId = (newValue: any) => {
    this.setState({
      courceId: newValue !== undefined ? newValue.value : undefined,
    });
  };
  onChangeAttachedInformation1Id = (newValue: any) => {
    this.setState({
      attachedInformation1Id:
        newValue !== undefined ? newValue.value : undefined,
    });
  };
  onChangeAttachedInformation2Id = (newValue: any) => {
    this.setState({
      attachedInformation2Id:
        newValue !== undefined ? newValue.value : undefined,
    });
  };
  onChangeAttachedInformation3Id = (newValue: any) => {
    this.setState({
      attachedInformation3Id:
        newValue !== undefined ? newValue.value : undefined,
    });
  };

  // 検索ボタン押す
  onSearch = async () => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      // backend通信し、ユーザ登録
      const postData: ExaminationSearchRequestBean = {
        fy: this.state.fy,
        entranceExam1Id: this.state.entranceExam1Id,
        entranceExam2Id: this.state.entranceExam2Id,
        entranceExam3Id: this.state.entranceExam3Id,
        facultyId: this.state.facultyId,
        departmentId: this.state.departmentId,
        majorId: this.state.majorId,
        courceId: this.state.courceId,
        attachedInformation1Id: this.state.attachedInformation1Id,
        attachedInformation2Id: this.state.attachedInformation2Id,
        attachedInformation3Id: this.state.attachedInformation3Id,
      };
      const result = await http<
        ExaminationSearchResponseBean[],
        ExaminationSearchRequestBean
      >({
        path: "/Examination/search",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok) {
        this.setState({ examinationList: result.body });
      } else {
        message.error(Messages["ERR-020"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  columns = [
    {
      title: <div className="table-title">No</div>,
      key: "no",
      render: (value: any, item: any, index: number) => (
        <span>{(this.state.page - 1) * this.state.pageSize + index + 1}</span>
      ),
    },
    {
      title: <div className="table-title">採点ステータス</div>,
      dataIndex: "status",
      key: "status",
      sorter: (a: any, b: any) => localeCompare(a.status, b.status),
      render: (value: any, item: any, index: number) => {
        //1：未採点、2：採点済、3：採点提出済、4：採点確定、5：合否判定中、6：合否確定
        if (item.status === null || item.status === "1") {
          return "未採点";
        } else if (item.status === "2") {
          return "採点済";
        } else if (item.status === "3") {
          return "採点提出済";
        } else if (item.status === "4") {
          return "採点確定";
        } else if (item.status === "5") {
          return "合否判定中";
        } else if (item.status === "6") {
          return "合否確定";
        }
      },
    },
    {
      title: <div className="table-title">入試年度</div>,
      dataIndex: "fy",
      key: "fy",
    },
    {
      title: <div className="table-title">入試制度1</div>,
      dataIndex: "entranceExam1Name",
      key: "entranceExam1Name",
      sorter: (a: any, b: any) =>
        localeCompare(a.entranceExam1Name, b.entranceExam1Name),
    },
    {
      title: <div className="table-title">入試制度2</div>,
      dataIndex: "entranceExam2Name",
      key: "entranceExam2Name",
      sorter: (a: any, b: any) =>
        localeCompare(a.entranceExam2Name, b.entranceExam2Name),
    },
    {
      title: <div className="table-title">入試制度3</div>,
      dataIndex: "entranceExam3Name",
      key: "entranceExam3Name",
      sorter: (a: any, b: any) =>
        localeCompare(a.entranceExam3Name, b.entranceExam3Name),
    },
    {
      title: <div className="table-title">学部</div>,
      dataIndex: "facultyName",
      key: "facultyName",
      sorter: (a: any, b: any) => localeCompare(a.facultyName, b.facultyName),
    },
    {
      title: <div className="table-title">学科</div>,
      key: "departmentName",
      dataIndex: "departmentName",
      sorter: (a: any, b: any) =>
        localeCompare(a.departmentName, b.departmentName),
    },
    {
      title: <div className="table-title">専攻</div>,
      key: "majorName",
      dataIndex: "majorName",
      sorter: (a: any, b: any) => localeCompare(a.majorName, b.majorName),
    },
    {
      title: <div className="table-title">コース</div>,
      key: "courceName",
      dataIndex: "courceName",
      sorter: (a: any, b: any) => localeCompare(a.courceName, b.courceName),
    },
    {
      title: <div className="table-title">付属情報1</div>,
      dataIndex: "attachedInformation1Name",
      key: "attachedInformation1Name",
      sorter: (a: any, b: any) =>
        localeCompare(a.attachedInformation1Name, b.attachedInformation1Name),
    },
    {
      title: <div className="table-title">付属情報2</div>,
      dataIndex: "attachedInformation2Name",
      key: "attachedInformation2Name",
      sorter: (a: any, b: any) =>
        localeCompare(a.attachedInformation2Name, b.attachedInformation2Name),
    },
    {
      title: <div className="table-title">付属情報3</div>,
      dataIndex: "attachedInformation3Name",
      key: "attachedInformation3Name",
      sorter: (a: any, b: any) =>
        localeCompare(a.attachedInformation3Name, b.attachedInformation3Name),
    },
    {
      title: <div className="table-title">編集</div>,
      key: "action",
      render: (text: any, record: any) => (
        <Space size="middle" direction="vertical">
          <AuthorityButton
            functioncode="FM-02"
            authority="2"
            type="primary"
            htmlType="button"
            onClick={() => {
              const { navigation } = this.props;
              navigation("/ExaminationRegister/" + record.examinationId, {
                state: {
                  fy: this.state.fy,
                  entranceExam1Id: this.state.entranceExam1Id,
                  entranceExam2Id: this.state.entranceExam2Id,
                  entranceExam3Id: this.state.entranceExam3Id,
                  facultyId: this.state.facultyId,
                  departmentId: this.state.departmentId,
                  majorId: this.state.majorId,
                  courceId: this.state.courceId,
                  attachedInformation1Id: this.state.attachedInformation1Id,
                  attachedInformation2Id: this.state.attachedInformation2Id,
                  attachedInformation3Id: this.state.attachedInformation3Id,
                },
              });
            }}
          >
            編集
          </AuthorityButton>
        </Space>
      ),
    },
  ];

  render(): React.ReactNode {
    return (
      <Page title="試験一覧" ref={this._page}>
        <div className="data_content">
          <Form
            name="user"
            colon={false}
            layout="horizontal"
            labelCol={{ span: 8 }}
            labelAlign="left"
            labelWrap={true}
            onFinish={this.onSearch}
            className="search_form"
            ref={this._form}
            initialValues={{
              fy: { value: this.state.fy },
              entranceExam1Id: this.state.entranceExam1Id,
              entranceExam2Id: this.state.entranceExam2Id,
              entranceExam3Id: this.state.entranceExam3Id,
              facultyId: this.state.facultyId,
              departmentId: this.state.departmentId,
              majorId: this.state.majorId,
              courceId: this.state.courceId,
              attachedInformation1Id: this.state.attachedInformation1Id,
              attachedInformation2Id: this.state.attachedInformation2Id,
              attachedInformation3Id: this.state.attachedInformation3Id,
            }}
          >
            <Row>
              <Col span={6}>
                <Form.Item
                  label="入試年度"
                  name="fy"
                  rules={[{ required: true }]}
                >
                  <CommonMasterSelect
                    masterType={31}
                    allowClear={false}
                    width={100}
                    onChange={this.onChangeFy}
                  />
                </Form.Item>
              </Col>
              <Col offset={14} span={4}>
                <Form.Item>
                  <AuthorityButton
                    functioncode="FM-02"
                    authority="2"
                    type="primary"
                    htmlType="submit"
                    onClick={() => {
                      const { navigation } = this.props;
                      navigation("/ExaminationRegister");
                    }}
                  >
                    新規登録
                  </AuthorityButton>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item label="入試制度1" name="entranceExam1Id">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    masterType={25}
                    width={160}
                    onChange={this.onChangeEntranceExam1Id}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="入試制度2" name="entranceExam2Id">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    fid={this.state.entranceExam1Id}
                    masterType={26}
                    width={160}
                    onChange={this.onChangeEntranceExam2Id}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="入試制度3" name="entranceExam3Id">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    fid={this.state.entranceExam2Id}
                    masterType={27}
                    width={160}
                    onChange={this.onChangeEntranceExam3Id}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item label="学部" name="facultyId">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    masterType={21}
                    width={160}
                    onChange={this.onChangeFacultyId}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="学科" name="departmentId">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    fid={this.state.facultyId}
                    masterType={22}
                    width={160}
                    onChange={this.onChangeDepartmentId}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="専攻" name="majorId">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    fid={this.state.departmentId}
                    masterType={23}
                    width={160}
                    onChange={this.onChangeMajorId}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="コース" name="courceId">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    fid={this.state.majorId}
                    masterType={24}
                    width={160}
                    onChange={this.onChangeCourceId}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item label="付属情報1" name="attachedInformation1Id">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    masterType={28}
                    width={160}
                    onChange={this.onChangeAttachedInformation1Id}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="付属情報2" name="attachedInformation2Id">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    masterType={29}
                    width={160}
                    onChange={this.onChangeAttachedInformation2Id}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="付属情報3" name="attachedInformation3Id">
                  <CommonMasterSelect
                    allowClear={true}
                    fy={this.state.fy}
                    masterType={30}
                    width={160}
                    onChange={this.onChangeAttachedInformation3Id}
                  />
                </Form.Item>
              </Col>
              <Col offset={2} span={4}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    検索
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <Table
            rowKey={(record: any) => record.examinationId}
            bordered
            pagination={{
              position: ["topRight"],
              pageSize: this.state.pageSize,
              onShowSizeChange: (current, pageSize) => {
                this.setState({ page: 1, pageSize: pageSize });
              },
              onChange: (page, pageSize) => {
                this.setState({ page: page });
              },
            }}
            columns={this.columns}
            dataSource={this.state.examinationList}
          />
        </div>
      </Page>
    );
  }
}

export default withRouterDom(UserList);
